import React, { useCallback, useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { refundTableColumnsConfig } from "./refundTableColumnsConfig";
import { Table } from "../../../component/table/Table";
import { openModal } from "../../../store/modalSlice";
import { useNavigate } from "react-router-dom";

const statusMap = {
  Approve: 15,
  Reject: 21,
};

export const RefundTablePage = ({ data }) => {
  const [columnDefs, setColumnDefs] = useState([]);
  const dispatch = useDispatch();
  console.log("refund", data);

  const navigate = useNavigate();

  const handleOpenModal = useCallback(
    (rowData, identifier) => {
      console.log("identifier:", identifier); // Optional debug

      dispatch(
        openModal({
          component: "DynamicForm",
          uiData: {
            heading: `${identifier} Request`,
            primaryButtonLabel: identifier,
            isGridRequired: true,
          },
          configData: {
            ...rowData,
            status: statusMap[identifier],
          },
          operationType: identifier,
          module: "refund",
        })
      );
    },
    [dispatch]
  );
  const handleRefundDetails = useCallback(
    (refundId) => {
      // dispatch(setOrderId({ order_id: rowId }));
      console.log("details", refundId);
      navigate(`${refundId}`);
    },
    [navigate]
  );
  useEffect(() => {
    setColumnDefs(refundTableColumnsConfig["refund"](handleOpenModal, handleRefundDetails));
  }, [handleOpenModal, handleRefundDetails]);

  return <Table data={data} columns={columnDefs} />;
};
